"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingsAndReviewsHeader = void 0;
const react_1 = __importDefault(require("react"));
const provider_components_1 = require("@kyruus/provider-components");
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const constants_1 = require("../../lib/constants");
const provider_profile_styles_1 = require("../../provider-profile.styles");
exports.RatingsAndReviewsHeader = (0, with_error_boundary_1.withErrorBoundary)(({ shouldHidePageAnchors, providerReviews, handleClickRatingReviewCount }) => {
    return (react_1.default.createElement(provider_profile_styles_1.ReviewsSummaryWrapper, null,
        react_1.default.createElement(provider_components_1.RatingsAndReviewsSummary, { providerReviews: providerReviews, shouldHidePageAnchors: shouldHidePageAnchors, ratingReviewCountHref: `#${constants_1.PROFILE_SECTION_IDS.REVIEWS}`, handleClickRatingReviewCount: handleClickRatingReviewCount })));
});
//# sourceMappingURL=RatingsAndReviewsHeader.js.map